import React from 'react';
import './style.scss';
import { AnimatedHeading, HoverText } from '../../shared/TextFx';

const TICKER_ITEMS = ['Worldwide Courier Services', 'Fast & Secure Delivery', 'Trusted Logistics Partner'];

const AboutSec = () => (
  <section className="about" id="about">
    <div className="container">
      <div className="about__container scale-block">
        {/* <div className="about__top opacity-block">
          <span className="about__top-text">About Us</span>
          <span className="about__top-text">Esquire Express</span>
        </div> */}

        <div className="about__container-inner">
          <AnimatedHeading className="about__title" text="Esquire manages urgent air movements through " />

          <div className="opacity-block">
            <p className="about__text">
              On Board Courier, Next Flight Out, NFO Express and Air Charter solutions, with 24/7 operational oversight from origin through final delivery.
            </p>
            <div className='btn-row-div'>
              <a className="about__btn text-hover btn" href="#about">
                <span className="btn__inner">
                  <HoverText words="Start a Critical Shipment" />
                </span>
              </a>
              <a className="about__btn text-hover btn" href="#about">
                <span className="btn__inner">
                  <HoverText words="Talk to Operations 24/7" />
                </span>
              </a>
            </div>

          </div>
        </div>

        {/* <div className="about__bottom">
          <div className="ticker">
            {TICKER_ITEMS.map((item, index) => (
              <span className="ticker__item" key={index}>
                {item}
              </span>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  </section>
);

export default AboutSec;
